export const getImageSize = (url, size = 'MEDIUM') => {
  //MEDIUM, SMALL, THUMBNAIL
  const imageArr = url.split('.');
  imageArr[imageArr.length - 2] += '_' + size.toUpperCase();

  return imageArr.join('.');
};